import { StorageType } from '@/typings/enum/Common'

// 登录页面地址
export const loginUrl = '/user/login'
// axios请求超时时间（单位: ms）
export const timeout = 300000
// token存储位置
export const tokenStoragePosition = StorageType.Local
export const UserRolesKeyPosition = StorageType.Local
export const UserOfficeKeyPosition = StorageType.Local
export const UserKeyPosition = StorageType.Local
export const MobileKeyPosition = StorageType.Local
export const UserDataAuthoritiesKeyPosition = StorageType.Local
// token存储key
export const tokenStorageKey = 'x-oy-token'
// 角色存储到key
export const UserRolesKey = 'x-oy-user-roles'
// 角色存储到key
export const UserHeadOfficeKey = 'x-oy-head-office'
// 当前角色 id
export const UserCurrentRoleIdKey = 'x-oy-current-role-id'
// 所有角色数据存储key
export const UserDataAuthoritiesKey = 'x-oy-data-authorities'

export const UserKey = 'x-oy-user'
export const UserMobile = 'x-oy-mobile'
export const UserIdKey = 'x-oy-user-id'
export const UserIdKeyPosition = StorageType.Local
// content-type
export const contentType = 'application/json;charset=UTF-8'
// token失效状态码
export const tokenInvalidCode = '403'
